export default __webpack_public_path__ + "static/media/allbirds-banner.e26fdce1.png";